// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2aFWw","fileBtn":"File_fileBtn___jhPS","closeBtn":"File_closeBtn__3pAKg","fileSelected":"File_fileSelected__2UxQ1","disabled":"File_disabled__1X96N"};